import { LIST_TYPES } from 'Utilities/consts';

export const VEHICLE_LIST_TAB_OPTIONS = [
	LIST_TYPES.auction,
	LIST_TYPES.aiCompanion,
	LIST_TYPES.buyItNow,
	LIST_TYPES.shortlist,
];
